import { Pipe, PipeTransform } from '@angular/core';
import { Params } from '@angular/router';
import * as _ from 'lodash';
import { ITableRowViewModel } from 'src/app/models/viewModels';

@Pipe({
  name: 'tableCell',
})
export class TableCellPipe implements PipeTransform {
  public transform(
    dict: { [key: string]: number | string | boolean | Date | Params | undefined } | ITableRowViewModel,
    propertyName: string
  ): number | string | boolean | Date | Params {
    const value = _.get(dict, propertyName);
    if (value === undefined) {
      return '';
    }

    return value;
  }
}
